define.alias("shared/components/shared/pre-boarding/context-modal/side-plan-card", "auth/components/shared/pre-boarding/context-modal/side-plan-card");